/* verqo — /preview/buyers (deprecated)
 *
 * Pattern A shipped Feb 2026: buyers live as a section on the main landing
 * (#for-buyers anchor). This route now redirects to keep any external links
 * (email signatures, social posts, investor decks) from breaking.
 */
import { useEffect } from "react";

export default function BuyersStub() {
  useEffect(() => {
    window.location.replace("/#for-buyers");
  }, []);
  return null;
}
